export default {
  about: {
    desc:
      "Our mission is to develop seamless, user-friendly free applications that streamline tasks and enhance productivity across multiple platforms. We believe in creating tools that make everyday life easier without compromising on quality or user experience.",
    title: "About Us",
    portfolio: {
      title: "Our Portfolio",
      mpc: {
        name: "Marriage Point Calculator",
        desc:
          "Introducing the 🃏 Marriage card game companion: The Marriage Point Calculator (Center Collection) mobile app! Never struggle with point calculations again with our easy-to-use and share interface.",
        playStore: "Get on Play Store",
        appStore: "Get on App Store",
        web: "Open Web App",
      },
      led: {
        name: "LED & Neon Signboard",
        desc1:
          "Transform your device into a digital signboard. Use your phone, tablet, or cast to Smart TV to display bright, eye-catching messages.",
        desc2: "Perfect for concerts and live events.",
        playStore: "Get on Play Store",
        appStore: "Get on App Store",
        web: "Open Web App",
      },
      tax: {
        name: "Tax Advisor Nepal",
        desc: "Calculate and find ways to lower and save tax.",
        web: "Open Web App",
      },
      sib: {
        name: "Self Improvement Budget App",
        desc:
          "A comprehensive budgeting application that empowers you to strategically allocate resources toward personal development, skill enhancement, and project completion to achieve your aspirational goals.",
        playStore: "Get on Play Store",
        appStore: "Get on App Store",
      },
      installOnMobile: "Install",
      openWebApp: "Open Web App", // fallback for generic buttons
    },
    team: {
      title: "Our Team",
      manoj: {
        name: "Manoj Shrestha",
        role: "Chief Executive Officer (CEO)",
        desc:
          "IT Business Expert with more than 10 years of experience with high level of expertise in utilizing IT to solve business problems.",
        profile: "View Profile",
      },
      pujan: {
        name: "Pujan Shrestha",
        role: "Chief Technical Officer (CTO)",
        desc:
          "Tech Expert with more than 7 years of experience in software development. He is responsible for all the technical aspect of the company and also works as a full stack developer.",
        profile: "View Profile",
      },
      learnMore: "Learn More", // fallback for generic button
    },

    description:
      "Welcome to our application! We strive to provide the best experience.",
  },
  share: {
    title: "Share",
    description: "Ask your friend to scan the QR code to install the app!",
  },
  privacy: {
    title: "Privacy Policy",
    date: "January 1, 2024",
    description:
      "Thank you for using our app. Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information.",
    sections: {
      1: {
        title: "Information We Collect",
        body:
          "Personal Information: We may collect your name, email address, or other contact details if you provide them voluntarily.\n\nUsage Data: We collect data on how you interact with the app, such as pages visited and features used.\n\nDevice Information: We may collect your device type, operating system, and app version for performance and troubleshooting.",
      },
      2: {
        title: "How We Use Your Information",
        body:
          "To provide and improve our services.\n\nTo personalize user experience.\n\nTo respond to your inquiries and provide support.\n\nTo send important updates or promotional messages (only with your consent).",
      },
      3: {
        title: "Sharing Your Information",
        body:
          "We do not sell your personal information. We may share information:\n\nWith trusted third-party services that help us operate the app.\n\nWhen required by law or to protect our legal rights.",
      },
      4: {
        title: "Data Security",
        body:
          "We implement appropriate technical and organizational measures to protect your data against unauthorized access, loss, or misuse.",
      },
      5: {
        title: "Your Rights",
        body:
          "You have the right to:\n\nAccess the information we hold about you.\n\nRequest corrections or deletions.\n\nWithdraw consent at any time.",
      },
      6: {
        title: "Third-Party Services",
        body:
          "Our app may use third-party services (e.g., analytics or ads) that have their own privacy policies. We recommend reviewing their policies as well.",
      },
      7: {
        title: "Changes to This Policy",
        body:
          "We may update this policy from time to time. Changes will be posted in the app with a new effective date.",
      },
      8: {
        title: "Contact Us",
        body:
          "If you have any questions or concerns about this policy, please contact us at: shrestha.applications@gmail.com",
      },
    },
  },
  terms: {
    title: "Terms of Use",
    description: "Please read these terms carefully before using the app.",
    sections: {
      1: {
        title: "Acceptance of Terms",
        body:
          "By accessing or using this application, you agree to comply with and be bound by these Terms and Conditions.",
      },
      2: {
        title: "Modification of Terms",
        body:
          "We reserve the right to change, modify, or revise these Terms at any time. Continued use of the app after such changes constitutes your acceptance of the new Terms.",
      },
      3: {
        title: "User Responsibilities",
        body:
          "You agree to use the app only for lawful purposes and not to engage in any activity that could harm the app or its users.",
      },
      4: {
        title: "Intellectual Property",
        body:
          "All content, features, and functionality in this app are the exclusive property of Shrestha Apps and are protected by copyright and other laws.",
      },
      5: {
        title: "Third-Party Services",
        body:
          "The app may contain links to third-party websites or services that are not owned or controlled by us. We are not responsible for the content or practices of any third-party sites.",
      },
      6: {
        title: "Disclaimer of Warranties",
        body:
          "The app is provided on an 'as is' and 'as available' basis. We make no warranties, expressed or implied, regarding the app’s operation or availability.",
      },
      7: {
        title: "Limitation of Liability",
        body:
          "In no event shall Shrestha Apps be liable for any damages arising out of or in connection with your use of the app.",
      },
      8: {
        title: "Indemnification",
        body:
          "You agree to indemnify and hold harmless Shrestha Apps from any claims, damages, or expenses arising from your use of the app.",
      },
      9: {
        title: "Termination",
        body:
          "We reserve the right to terminate or suspend your access to the app at any time, without notice, for any reason.",
      },
      10: {
        title: "Governing Law",
        body:
          "These Terms shall be governed and construed in accordance with the laws of Nepal, without regard to its conflict of law provisions.",
      },
      11: {
        title: "Contact Us",
        body:
          "If you have any questions about these Terms, please contact us at shresthaapps@gmail.com.",
      },
      12: {
        title: "Entire Agreement",
        body:
          "These Terms constitute the entire agreement between you and Shrestha Apps regarding your use of the app.",
      },
    },
    title: "Terms and Conditions",
    description:
      "Please read our terms and conditions carefully before using our app.",
  },
  footer: {
    copyright: " {year} Shrestha Apps",
    allRightsReserved: "All rights reserved",
    tagline: "Creating apps that make life easier.",
    nepal: "Nepal",
    japan: "Japan",
    usa: "USA",
    email: "Email",
  },
};
